export const monCompteListeDeCoursesOverviewProps = () => ({
  listes: {
    type: Array,
    required: false,
    default: () => []
  },
  count: {
    type: [Number, String],
    required: true
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false
  }
})
